/**
 * Copy text to the clipboard. Works on HTTP LAN hosts where
 * navigator.clipboard is unavailable (requires a secure context).
 */
export async function copyTextToClipboard(text, { sourceElement } = {}) {
  if (!text) return false;

  if (sourceElement instanceof HTMLTextAreaElement || sourceElement instanceof HTMLInputElement) {
    const el = sourceElement;
    const hadReadOnly = el.readOnly;
    try {
      el.readOnly = false;
      el.focus();
      el.select();
      el.setSelectionRange(0, text.length);
      if (document.execCommand("copy")) return true;
    } catch {
      /* try other methods */
    } finally {
      el.readOnly = hadReadOnly;
    }
  }

  const hidden = document.createElement("textarea");
  hidden.value = text;
  hidden.setAttribute("readonly", "");
  hidden.style.cssText =
    "position:fixed;top:0;left:0;width:2em;height:2em;padding:0;border:none;outline:none;box-shadow:none;background:transparent;opacity:0;";
  document.body.appendChild(hidden);
  hidden.focus();
  hidden.select();
  hidden.setSelectionRange(0, text.length);
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(hidden);
  if (ok) return true;

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* fall through */
    }
  }

  return false;
}
